import {
  SHELL_BRIEF_TAB_INDEX,
  isBriefTabInShellPath,
} from "@utils/bridge/shellTabPathPolicy";
import { getBridge, isUnifiedNativeMainShell } from "@/src/lib/bridge";

import { ROUTER_PATH } from "@config/router";
import { appTypes } from "@config/seo";
import { isValidLocale } from "@utils/i18n.locale";
import { normalizePathname } from "@utils/routeNormalizer";

/** Preserve locale / device prefix from current URL and build Brief path. */
const buildBriefHref = (): string => {
  const segments = window.location.pathname.split("/").filter(Boolean);
  const prefix: string[] = [];
  let index = 0;

  if (segments[0] && isValidLocale(segments[0])) {
    prefix.push(segments[0]);
    index = 1;
  }
  if (index < segments.length && appTypes.includes(segments[index])) {
    prefix.push(segments[index]);
  }

  const briefPath = normalizePathname(ROUTER_PATH.BRIEF);
  return prefix.length > 0 ? `/${prefix.join("/")}${briefPath}` : briefPath;
};

/**
 * Onboarding Welcome CTA: close only when already on Brief shell path; otherwise navigate to Brief.
 * Catchup 未读信号在 Brief，不是 Invest/Opportunity（EDG-385）。
 */
export const navigateToBriefFromOnboardingWelcome = (): void => {
  if (typeof window === "undefined") {
    return;
  }

  const pathname = normalizePathname(window.location.pathname);
  if (isBriefTabInShellPath(pathname)) {
    return;
  }

  if (getBridge().isInApp()) {
    if (isUnifiedNativeMainShell()) {
      window.location.assign(buildBriefHref());
      return;
    }
    getBridge().switchShellTab(SHELL_BRIEF_TAB_INDEX);
    return;
  }

  window.location.assign(buildBriefHref());
};
